import { TRANSFER_ORDER_STATUS } from 'constants/constants';
import { FilterFromUrlResponseType } from 'types/commons';
import dayjs from 'dayjs';
import RangePickerFilter from '../components/RangePickerFilter';
import { omit, values } from 'lodash';
import { getQueryString } from 'api/utils';
import { convertRequestParams } from '@redux/crudCreator/dataProvider';
import { DynamicObjectType } from 'core/types/common';
import { newCheckRole } from 'utils/tools';

const getCommonFilters = (searchParams, filter) => [
  searchParams.get('customLayout') &&
  Object.keys(TRANSFER_ORDER_STATUS).includes(searchParams.get('customLayout'))
    ? {
        condition: 'and',
        key: 'status',
        operator: 'is',
        value: searchParams.get('customLayout'),
      }
    : {},
  !filter?.filters?.find((item) => item.key === 'createdAt')
    ? {
        condition: 'and',
        key: 'createdAt',
        operator: 'gte',
        value: dayjs().subtract(1, 'month').startOf('month').toISOString(),
      }
    : {},
  !filter?.filters?.find((item) => item.key === 'createdAt')
    ? {
        condition: 'and',
        key: 'createdAt',
        operator: 'lte',
        value: dayjs().endOf('day').toISOString(),
      }
    : {},
];

const exportExcelQuery = (restInitialFilter, filter) => {
  const filterData = {
    filters: [
      ...values(restInitialFilter?.filters || {}),
      ...values(filter.filters || {}),
    ],
    orderBy: 'createdAt',
  };
  const requestParams = getQueryString(
    convertRequestParams(
      'GET_ALL',
      omit(filterData, ['join']) as DynamicObjectType,
    ),
  );
  return `/export-transfers?${requestParams?.replace('page=1&limit=10', '')}`;
};

const hasExport = (roles, byPass) => {
  return newCheckRole('/export-transfers', 'GET', roles, byPass);
};

export const getListProps = (status, searchParams, filter, roles, byPass) => {
  const commonFilters = getCommonFilters(searchParams, filter);
  const restInitialFilter: FilterFromUrlResponseType = {
    join: ['order'],
    filters: commonFilters,
  };

  const defaultProps = {
    initialFilter: {
      join: ['order'],
      filters: commonFilters,
    },
    model: 'transferOrders',
    rowSelectionActions: <></>,
    hasImport: false,
    hasExport: false,
    searchOperator: searchParams.get('fieldSearch') === 'id' ? 'eq' : 'contL',
    extraActionFilters: [<RangePickerFilter />],
  };

  switch (status) {
    case TRANSFER_ORDER_STATUS['AWAITING_CONFIRMATION']?.value:
    case TRANSFER_ORDER_STATUS['REJECTED']?.value:
    case TRANSFER_ORDER_STATUS['COMPLETED']?.value:
    case TRANSFER_ORDER_STATUS['CANCELLED']?.value:
      return defaultProps;
    case TRANSFER_ORDER_STATUS['CONFIRMED_PICK']?.value:
      return {
        ...defaultProps,
        model: 'transferConfirmedPick',
      };
    case TRANSFER_ORDER_STATUS['SHIPPING']?.value:
      return {
        ...defaultProps,
        model: 'transferOrdersBatch',
        initialFilter: {
          join: [],
          filters: [],
        },
      };
    default:
      return {
        ...defaultProps,
        hasExport: hasExport(roles, byPass),
        extraActionFilters: <RangePickerFilter />,
        exportExcelQuery: `${exportExcelQuery(restInitialFilter, filter)}`,
        excelName: `Export_transfers_${dayjs().format('YYYY_MM_DD')}`,
      };
  }
};
